import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";

import { AppComponent } from "./app.component";
import { NavMenuComponent } from "./nav-menu/nav-menu.component";
import { HomeComponent } from "./home/home.component";
import { CounterComponent } from "./counter/counter.component";
import { FetchDataComponent } from "./fetch-data/fetch-data.component";
import { routes } from "./routes";
import { AllCoursesResolver } from "./resolvers/allcourses.resolver";
import { CourseService } from "./Services/course.service";
import { ApiService } from "./Services/api.service";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { CourseDetailsComponent } from "./course-details/course-details.component";
import { CourseResolver } from "./resolvers/course.resolver";
import { CookieService } from "ngx-cookie-service";
import { CartComponent } from "./cart/cart.component";
import { CartUpdateService } from "./Services/cartUpdate.service";
import { CartDetailsComponent } from "./cart-details/cart-details.component";
import { AddedCoursesResolver } from "./resolvers/addedCourses.resolver";
import { CartItemsCookieService } from "./Services/cartItemsCookie.service";
import { HttpJsonInterceptor } from "./http-json.interceptor";
import { SnotifyModule, SnotifyService, ToastDefaults } from "ng-snotify";
import { WorkShopsComponent } from "./work-shops/work-shops.component";
import { RegistrationComponent } from "./registration/registration.component";
import { RegistrationFormComponent } from "./registration-form/registration-form.component";
import { TeamComponent } from "./team/team.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { ContactFormComponent } from "./contact-form/contact-form.component";
import { ContactService } from "./Services/contact.service";
import { RegistrationCourseCardComponent } from "./registration-course-card/registration-course-card.component";
import { NgxPayPalModule } from "ngx-paypal";
import { CoursesByCategoryComponent } from "./courses-by-category/courses-by-category.component";

import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { InteracDialogComponent } from "./interac-dialog/interac-dialog.component";
import { MatRadioModule } from "@angular/material";
import { ShareDialogComponent } from "./share-dialog/share-dialog.component";
import { CourseOneComponent } from "./course-one/course-one.component";
import { CourseTwoComponent } from "./course-two/course-two.component";
import { CourseThreeComponent } from "./course-three/course-three.component";
import { CourseFourComponent } from "./course-four/course-four.component";
import { CourseFiveComponent } from "./course-five/course-five.component";
import { CourseSixComponent } from "./course-six/course-six.component";
import { CourseSevenComponent } from "./course-seven/course-seven.component";
import { CourseNineComponent } from "./course-nine/course-nine.component";
import { CourseTenComponent } from "./course-ten/course-ten.component";
import { CourseElevenComponent } from "./course-eleven/course-eleven.component";
import { CourseThirteenComponent } from "./course-thirteen/course-thirteen.component";
import { CourseFourteenComponent } from "./course-fourteen/course-fourteen.component";
import { CourseDetailsWrapperComponent } from "./course-details-wrapper/course-details-wrapper.component";
import { CourseTwelveComponent } from "./course-twelve/course-twelve.component";

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    CourseDetailsComponent,
    CartComponent,
    CartDetailsComponent,
    WorkShopsComponent,
    RegistrationComponent,
    RegistrationFormComponent,
    TeamComponent,
    AboutUsComponent,
    ContactUsComponent,
    ContactFormComponent,
    RegistrationCourseCardComponent,
    CoursesByCategoryComponent,
    InteracDialogComponent,
    ShareDialogComponent,
    CourseOneComponent,
    CourseTwoComponent,
    CourseThreeComponent,
    CourseFourComponent,
    CourseFiveComponent,
    CourseSixComponent,
    CourseSevenComponent,
    CourseNineComponent,
    CourseTenComponent,
    CourseElevenComponent,
    CourseThirteenComponent,
    CourseDetailsWrapperComponent,
    CourseTwelveComponent,
    CourseFourteenComponent,
  ],
  entryComponents: [InteracDialogComponent, ShareDialogComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    HttpClientModule,
    FormsModule,
    AngularFontAwesomeModule,
    SnotifyModule,
    NgxPayPalModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatDialogModule,
    MatRadioModule,
  ],
  exports: [
    AngularFontAwesomeModule,
    SnotifyModule,
    // MatMenuModule,
    // MatButtonModule,
    // MatIconModule,
    // MatCardModule,
    // MatTabsModule,
    // MatSidenavModule,
    // MatListModule,
    // MatToolbarModule,
    // MatInputModule,
    // MatTableModule,
    // MatPaginatorModule,
    // MatSortModule,
    // MatProgressSpinnerModule,
    // MatDialogModule,
    // MatSelectModule,
    // MatDatepickerModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpJsonInterceptor, multi: true },
    { provide: "SnotifyToastConfig", useValue: ToastDefaults },
    SnotifyService,
    AllCoursesResolver,
    CourseResolver,
    AddedCoursesResolver,
    CourseService,
    ApiService,
    CookieService,
    CartUpdateService,
    CartItemsCookieService,
    ContactService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts